/* 时间格式化（友好相对时间）—— Notes.vue 与 CommentSection.vue 共用 */
export function pad(n) {
  return n < 10 ? '0' + n : '' + n
}
export function formatTime(t) {
  if (!t) return ''
  let d = new Date(t)
  if (isNaN(d.getTime())) {
    d = new Date(String(t).replace(/-/g, '/'))
  }
  if (isNaN(d.getTime())) return String(t)
  const diff = Date.now() - d.getTime()
  const minute = 60 * 1000
  const hour = 60 * minute
  const day = 24 * hour
  if (diff < minute) return '刚刚'
  if (diff < hour) return Math.floor(diff / minute) + ' 分钟前'
  if (diff < day) return Math.floor(diff / hour) + ' 小时前'
  if (diff < 2 * day) return '昨天 ' + pad(d.getHours()) + ':' + pad(d.getMinutes())
  return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) +
      ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes())
}
